/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Small_Mantis_QuellInputs */

const fr_quick_small_mantis_quell = /** @type {(inputs: Quick_Small_Mantis_QuellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

/**

* @param {Quick_Small_Mantis_QuellInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quick_small_mantis_quell = /** @type {((inputs?: Quick_Small_Mantis_QuellInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Small_Mantis_QuellInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quick_small_mantis_quell(inputs)
});